import * as WGS84Util from "@/utils/WGS84Util";
import Location from "./Location";

export default class Vector2D {
  constructor(x, y) {
    this._x = x;
    this._y = y;
  }

  rotate(radian, center) {
    if (center === null) {
      center = new Vector2D(0, 0);
    }

    const tmpV = new Vector2D(this.x - center.x, this.y - center.y);
    return new Vector2D(
      Math.cos(radian) * tmpV.x - Math.sin(radian) * tmpV.y + center.x,
      Math.sin(radian) * tmpV.x + Math.cos(radian) * tmpV.y + center.y
    );
  }

  toLocation() {
    const tempE = Math.exp((2.0 * this.y) / WGS84Util.SEMI_MINOR_AXIS);
    const tempR = Math.sqrt(Math.pow(2.0 - tempE, 2.0) - 4 * (1.0 - tempE));
    const sinLat = (-2.0 + tempE + tempR) / (2.0 * (1.0 + tempE));
    const latitude = (Math.asin(sinLat) * 180.0) / Math.PI;
    const longitude = (this.x * 180.0) / Math.PI / WGS84Util.SEMI_MAJOR_AXIS;

    return new Location(latitude, longitude);
  }

  get x() {
    return this._x;
  }

  get y() {
    return this._y;
  }
}
